import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import PropTypes from "prop-types";
import cx from "classnames";

function TablistNav(
  {
    name,
    options,
    defaultActive,
    callback = () => {}
  },
  { locals: { query = {}, path } }
) {
  const active = defaultActive || get(query, name);
  return (
    <nav role="tablist">
      <input type="hidden" name={name} value={active} />
      {map(options, ({ value, text, href, IconImg = "" ,dataStatus}) => {
        const searchString = `${encodeURIComponent(name)}=${encodeURIComponent(
          value
        )}`;

        const newHref = href ? href : `/actions/refresh?${searchString}`;
        return (
          <a
            key={value}
            onClick={() => {
              callback(value);
            }}
            href={newHref}
            aria-current={(href
              ? path === href || value === active
              : query[name]
              ? path.includes(searchString) || value === query[name]
              : value === active || path.includes(searchString))? true : undefined}
              role="link"
            data-status={dataStatus}
          >
            {IconImg && <IconImg />}
            {text}
          </a>
        );
      })}
    </nav>
  );
}

TablistNav.contextTypes = { locals: PropTypes.object };

export default TablistNav;
